import Vue from 'vue';
import App from './App.vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import BootstrapVue from 'bootstrap-vue';
import Toasted from 'vue-toasted';
import Loading from 'vue-loading-overlay';
import VueCookies from 'vue-cookies';
import PortalVue from 'portal-vue';
import * as VueGoogleMaps from 'vue2-google-maps';

import Login from './components/Login.vue';
import Register from './components/Register.vue';
import PlatformSelection from './components/PlatformSelection.vue';

import InvContainer from './components/inventory/InvContainer.vue';
import Dashboard from './components/inventory/Dashboard.vue';

import Items from './components/inventory/items/Items.vue';
import History from './components/inventory/items/History.vue';
import MoveItems from './components/inventory/items/MoveItems.vue';
import RecieveItems from './components/inventory/items/ReceiveItems.vue';
import AdjustItems from './components/inventory/items/AdjustItems.vue'

import Keys from './components/inventory/keys/Keys.vue';
import AddKey from './components/inventory/keys/AddKey.vue';

import Vehicles from './components/inventory/vehicles/Vehicles.vue';
import AddVehicle from './components/inventory/vehicles/AddVehicle.vue';

import AdminContainer from './components/admin/AdminContainer.vue'
import Users from './components/admin/Users.vue';
import Location from './components/admin/Location.vue';
import Programmers from './components/admin/Programmers.vue';
import Suppliers from './components/admin/Suppliers.vue';
import UploadInventory from './components/admin/UploadInventory.vue'
import JobMap from './components/scheduling/JobMap.vue'


import SchContainer from './components/scheduling/SchContainer.vue';
import Calendar from './components/scheduling/Calendar.vue';
import Technicians from './components/scheduling/Technicians.vue';
import JobHistory from './components/scheduling/JobHistory.vue';
import Reschedule from './components/scheduling/Reschedule.vue';



import {
  APIService
} from './Api.js';
import Overlay from './Loading.js';

import VModal from 'vue-js-modal';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'vue-select/dist/vue-select.css';
import vuetify from './plugins/vuetify';



Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(BootstrapVue);
Vue.use(VueRouter);
Vue.use(Toasted);
Vue.use(Loading);
Vue.use(VModal);
Vue.use(VueCookies);
Vue.use(PortalVue);

//Importing Google Maps
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC3zyYHKFzbF0utytcqzp9MyKs27MiMkgs',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
 
    //// If you want to set the version, you can do so:
    // v: '3.26',
    }
  })

// kick off the polyfill!
//smoothscroll.polyfill();

// set default config
VueCookies.config('7d');
// set global cookie
VueCookies.set('theme', 'default');
VueCookies.set('hover-time', '1s');

Vue.prototype.$overlay = new Overlay();
Vue.prototype.$api = new APIService();

const routes = [
  //{ path: '*', redirect: '/login' },
  {
    name: 'login',
    path: '/login',
    component: Login
  },
  {
    name: 'register',
    path: '/register',
    component: Register
  },
  {
    name: 'inventory',
    path: '/inventory',
    component: InvContainer
  },
  {
    name:'home',
    path:'/home',
    component: PlatformSelection
  },
  {
    name: 'admin',
    path: '/admin',
    component: AdminContainer,
    children: [
      {
        path: 'users',
        component: Users
      },
      {
        path: 'locations',
        component: Location
      },
      {
        path: 'suppliers',
        component: Suppliers
      },
      {
        path: 'programmers',
        component: Programmers
      },
      {
        path: 'upload',
        component: UploadInventory
      },      
    ]
  },
  {
    name: '/inventory',
    path: '/inventory',
    component: InvContainer,
    children: [{
        path: 'dashboard',
        component: Dashboard
      },
      {
        name: "recieve",
        path: 'items/receive',
        component: RecieveItems
      },
      {
        name: "items",
        path: 'items/find',
        component: Items
      },
      {
        name: "move",
        path: 'items/move',
        component: MoveItems
      },
      {
        name: "history",
        path: 'items/history',
        component: History
      },
      {
        name: "adjust",
        path: 'items/adjust',
        component: AdjustItems
      },
      {
        path: 'keys',
        component: Keys,
        children: [{
          path: 'new',
          component: AddKey
        }, ]
      },
      {
        path: 'vehicles',
        component: Vehicles,
        children: [{
          path: 'new',
          component: AddVehicle
        }]
      }
    ]
  },
  {
    name: '/scheduling',
    path: '/scheduling',
    component: SchContainer,
    children: [{
        path: 'dashboard',
        component: Dashboard
      },
      {
        path: 'Calendar',
        component: Calendar
      },
      {
        path: 'reschedule',
        component: Reschedule
      },
      {
        name: "jobHistory",
        path: 'history',
        component: JobHistory
      },
      {
        path: 'technicians',
        component: Technicians
      },
      {
        path: 'map',
        component: JobMap
      },
    ]
  }

]

const router = new VueRouter({
  routes,
  mode: 'history',
});

router.beforeEach((to,from,next) => {
  if(store.state.token == null){
    if(to.name != "register" && to.name != "login"){
      next("login");
      return;
    }
  }
  next();
  return;
})

const store = new Vuex.Store({
  state: {
    token: null,
    isAdmin: true,
    isManager: true,
    isTech: true,
    isScheduler: true,
    job: {
      customer: {
        phone: null,
        fname: null,
        lname: null,
        caa_card: null,
        company: null,
        channel: null,
        email: null,
        owner:false
      },
      from: null,
      to: null,
      date: null,
      jobType: null,
      address: null,
      quote: null,
      opRemarks: null,
      user: null,
      oem:null,
      make:null,
      model:null,
      year:null
    },
    locations:null
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setAdmin(state, isAdmin) {
      state.isAdmin = isAdmin;
    },
    setManager(state, isManager) {
      state.isManager = isManager;
    },
    setTech(state, isTech) {
      state.isTech = isTech;
    },
    setScheduler(state, isScheduler) {
      state.isScheduler = isScheduler;
    }
  },
});


new Vue({
  render: h => h(App),
  router: router,
  vuetify,
  store: store
}).$mount('#app')
